import { render, staticRenderFns } from "./SendReviewEmailModal.vue?vue&type=template&id=38e78370&"
import script from "./SendReviewEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendReviewEmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports